import {http} from '../utils'

const searchAction = (params) => {
  const url = `/task/job/page`
  return http.post(url, params)
}
const optionsAction = () => {
  const url = `/task/job/options`
  return http.post(url, {})
}
const addAction = (params) => {
  const url = `/task/job/save`
  return http.post(url, params)
}
const getAction = (params) => {
  const url = `/task/job/getOne`
  return http.post(url, params)
}
const scheduleAction = (params) => {
  const url = `/task/job/active`
  return http.post(url, params)
}
const deleteAction = (params) => {
  const url = `/task/job/delete`
  return http.post(url, params)
}
const detailsAction = (params) => {
  const url = `/task/job/job/log/page`
  return http.post(url, params)
}
const getNameDropdown = (directionType, id) => {
  const url = `/config/apiConfigInfo/getApiConfigListOnlyHttp/${directionType}/${id}`
  return http.post(url, {})
}

const getBatchDetail = batchId => {
  const url = `/task/job/job/log/batch/${batchId}`
  return http.post(url)
}
export default {
  searchAction,
  optionsAction,
  addAction,
  getAction,
  scheduleAction,
  deleteAction,
  detailsAction,
  getNameDropdown,
  getBatchDetail
}
